// Replace with toLocaleString
import numeral from "numeral";
import { Grid, Typography } from "@mui/material";
import { type Metrics as SocialMetrics } from "@commercial-publishing/shared-types/social";

export const Metrics = ({
  data,
  classes,
}: {
  data: SocialMetrics;
  classes: any;
}) => {
  return (
    <Grid item xs={12} sm={12} md={12} className={classes.dfpMetricsWrapper}>
      {data.impressions && (
        <Typography variant="h6" className={classes.dfpMetricsValueBold}>
          Impressions: {data.impressions.toLocaleString()}
        </Typography>
      )}
      {data.reach && (
        <Typography variant="h6" className={classes.dfpMetricsValueBold}>
          Reach: {data.reach.toLocaleString()}
        </Typography>
      )}
      {data.interactions && data.reach && (
        <Typography variant="h6" className={classes.dfpMetricsValueBold}>
          Interaction Rate:{" "}
          {numeral((data.interactions / data.reach) * 100).format("0.000")}%
        </Typography>
      )}
      {data.reactions && (
        <Typography variant="h6" className={classes.dfpMetricsValueBold}>
          Reactions: {numeral(data.reactions).format()}
        </Typography>
      )}
      {data.comments && (
        <Typography variant="h6" className={classes.dfpMetricsValue}>
          Comments: {numeral(data.comments).format()}
        </Typography>
      )}
      {data.shares && (
        <Typography variant="h6" className={classes.dfpMetricsValue}>
          Shares: {data.shares}
        </Typography>
      )}
      {data.saved && (
        <Typography variant="h6" className={classes.dfpMetricsValue}>
          Saved: {numeral(data.saved).format()}
        </Typography>
      )}
      {data.postClicks && (
        <Typography variant="h6" className={classes.dfpMetricsValue}>
          Post Clicks: {data.postClicks}
        </Typography>
      )}
      {data.outboundClicks && (
        <Typography variant="h6" className={classes.dfpMetricsValue}>
          Outbound Clicks: {data.outboundClicks}
        </Typography>
      )}
      {(data.outboundClicks || data.postClicks) && data.impressions && (
        <Typography variant="h6" className={classes.dfpMetricsValue}>
          CTR:{" "}
          {numeral(
            (data.outboundClicks || data.postClicks || 0) / data.impressions,
          ).format("0.000%")}
        </Typography>
      )}
    </Grid>
  );
};
